module.exports = __webpack_public_path__ + "static/media/game-icon.d1cbe053.png";